import { useTranslation } from 'react-i18next';
import { CheckExpandable } from '@/components/CheckExpandable';
import { SectionHeader } from '@/components/SectionHeader';
import { Button, Card, Form, Grid, Input } from '@arco-design/web-react';
import { IconDelete, IconPlus } from '@arco-design/web-react/icon';
import styled from 'styled-components';
import { GrayBox, ItemTitle } from '../tools';
import { WorkloadComponent, WorkloadType } from '../types';
import { MetadataItem, useAddMetadataStore } from './useAddMetadataStore';

const FormList = Form.List;
const FormItem = Form.Item;
const Row = Grid.Row;
const Col = Grid.Col;

const { DEPLOYMENT } = WorkloadType;

interface AddMetadataProps extends WorkloadComponent {}

export function AddMetadata({ module = DEPLOYMENT }: AddMetadataProps) {
  const { t } = useTranslation();
  const [form] = Form.useForm<{ metadata: MetadataItem[] }>();

  const msg = {
    add_metadata: t('components:add.metadata'),
    add_metadata_desc: t('components:add.metadata.for.pod.replicas'),
    notes: t('components:annotations'),
    add: t('common:add'),
    key: t('common:key'),
    value: t('common:value'),
  };

  const { metadata, updateMetadata } = useAddMetadataStore();

  // 如果存在元数据 key 为空,那么禁用添加按钮
  const isDisabledAddButton = metadata?.some((item) => !item?.key);

  const Header = (
    <SectionHeader inline title={msg.add_metadata} description={msg.add_metadata_desc} />
  );
  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{
        metadata: metadata?.length ? metadata : [undefined],
      }}
      onValuesChange={(_, values) => {
        updateMetadata(values.metadata);
      }}
    >
      <Card style={{ marginTop: '1rem' }}>
        <CheckExpandable type="fold" label={Header}>
          <Content>
            <GrayBox>
              <ItemTitle style={{ marginBottom: '1rem' }}>{msg.notes}</ItemTitle>
              <FormList field="metadata">
                {(fields, { add, remove }) => {
                  return (
                    <>
                      {fields.map((field, index) => {
                        return (
                          <Row gutter={8} key={field.key}>
                            <Col span={11}>
                              <FormItem field={`${field.field}.key`}>
                                <Input placeholder={msg.key} />
                              </FormItem>
                            </Col>
                            <Col span={11}>
                              <FormItem field={`${field.field}.value`}>
                                <Input placeholder={msg.value} />
                              </FormItem>
                            </Col>
                            <Col span={2}>
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                  icon={<IconDelete />}
                                  type="text"
                                  status="danger"
                                  onClick={() => remove(index)}
                                />
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                      <div>
                        <Button
                          icon={<IconPlus />}
                          size="mini"
                          type="primary"
                          disabled={isDisabledAddButton}
                          onClick={() => add()}
                          style={{ marginTop: '1rem' }}
                        >
                          {msg.add}
                        </Button>
                      </div>
                    </>
                  );
                }}
              </FormList>
            </GrayBox>
          </Content>
        </CheckExpandable>
      </Card>
    </Form>
  );
}

/** ============================ 样式 ==================================== */
const Content = styled.div`
  margin-top: 1rem;
`;
